/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const CREATE_BUDGET_URL = `${API_URL}/budgets`;
